import Image from 'next/image';
import imgFood from '@/assets/image 17.png';
import { PlusCircleIcon } from '@heroicons/react/24/solid';
import { useRouter } from 'next/navigation';
import { truncateText } from '@/utils/helpers';
import { Blog } from '@/types/Blog.types';

type Props = {
  item: Blog;
};

const NewsCard = ({ item }: Props) => {
  const router = useRouter();
  return (
    <div
      onClick={() => router.push(`/blog/${item._id}`)}
      className=" bg-white rounded-3xl overflow-clip h-[28rem]"
    >
      <div className="w-full h-[250px] bg-crunchies-red grow-0 shrink-0">
        <img
          src={item.image_url}
          alt="image of food"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex flex-col gap-2 grow py-3 lg:py-8 px-4 lg:px-8">
        <div className="flex gap-1 text-xs items-center text-gray-400">
          <PlusCircleIcon className="w-1 h-1 text-primary-400" />
          {item.category}
        </div>
        <h1 className="text-lg lg:text-2xl font-bold">{item.title}</h1>
        <div
          dangerouslySetInnerHTML={{ __html: truncateText(item.content, 100) }}
        />
      </div>
    </div>
  );
};

export default NewsCard;
